import { AuthService } from '@app/account/services/auth.service';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { IUsersService } from '@shared/interfaces/users-service.interface';
import { LoginResponse } from '@app/account/models/login-response.model';
import { Observable, of } from 'rxjs';
import { Router, Route, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable()
export class AuthGuard {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private usersService: IUsersService = inject(IUsersService);

  public canLoad(route: Route): Observable<boolean | UrlTree> {
    return this.checkAuthenticated(route.path);
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkAuthenticated(state.url);
  }

  public checkAuthenticated(url: string | undefined): Observable<boolean | UrlTree> {
    return this.usersService.isUserProfileAvailable.pipe(
      take(1),
      switchMap((authenticated: boolean): Observable<boolean | UrlTree> => {
        if (authenticated) {
          return of(true);
        }
        // If the authentication cookie is present in the browser the getLoggedUserProfile
        // will return us back its profile (including its roles) and the user is allowed to navigate
        return this.authService.getLoggedUserProfile().pipe(
          take(1),
          map((response: LoginResponse): boolean | UrlTree => response.isAuthenticated ? true : this.createLoginUrlTree(url)),
          catchError((): Observable<UrlTree> => of(this.createLoginUrlTree(url)))
        );
      })
    );
  }

  private createLoginUrlTree(url: string | undefined): UrlTree {
    return this.router.createUrlTree(['/account', 'login'], { queryParams: { returnUrl: url } });
  }
}
